import { bindActionCreators } from 'redux';
import { O2OCommonContainer } from "../../common/container/O2OContainer";
import { IState } from "../../redux/reducer";
import { getLinkOrg, linkOrg } from './link-orgs/action/LinkOrgsAction';
import { addOrgs, autoCreateCustomModelByPModel, deleteOrg, getOrgs, updateOrg } from './OrgsAction';
import { OrgsComponentV2 } from "./OrgsComponentV2";


function mapStateToProps(rootState: IState) {
  return {
    organizations: rootState.organizations,
    user: rootState.user,
    commonResponse: rootState.commonResponse,
    linkOrgsNoContent: rootState.linkOrgsNoContent
  };
}


function mapDispatchToProps(dispatch: any) {
  return {
    getOrgs: bindActionCreators(getOrgs, dispatch),
    addOrgs: bindActionCreators(addOrgs, dispatch),
    deleteOrg: bindActionCreators(deleteOrg, dispatch),
    updateOrg: bindActionCreators(updateOrg, dispatch),
    linkOrg: bindActionCreators(linkOrg, dispatch),
    getLinkOrg: bindActionCreators(getLinkOrg, dispatch),
    autoCreateCustomModelByPModel: bindActionCreators(autoCreateCustomModelByPModel, dispatch)
  };
}

export const OrganizationContainer = O2OCommonContainer(OrgsComponentV2, mapStateToProps, mapDispatchToProps)
